import { PictureSources, ReviewData, ReviewsOpinionRecords } from 'features/reviews';
import React from 'react';
import { Breakpoint } from 'types/utils';
import { jcm } from 'utils';
import { reviewCardFirst } from '../styles';
import { ReviewCard } from './review-card';
import { ReviewsPaginationPageSkeleton } from './skeletons';
import { extractReviewsOpinion } from './utils';

export const ReviewsPaginationFirstPage: React.FC<{
  reviewsCards: ReviewData[];
  reviewsAreLoading: boolean;
  breakpoint: Breakpoint;
  onShowPicture: (pic: PictureSources | null) => void;
  reviewsOpinions: ReviewsOpinionRecords[];
  onLike: (reviewsId: string) => void;
  onCancelLike: (reviewsId: string) => void;
  onCancelDislike: (reviewsId: string) => void;
  onDislike: (reviewsId: string) => void;
  onChangeDislikeToLike: (reviewsId: string) => void;
  onChangeLikeToDislike: (reviewsId: string) => void;
}> = ({
  breakpoint,
  reviewsCards,
  reviewsAreLoading,
  reviewsOpinions,
  onShowPicture,
  onLike,
  onDislike,
  onCancelLike,
  onCancelDislike,
  onChangeDislikeToLike,
  onChangeLikeToDislike,
}) => {
  const extractedReviewOpinion = extractReviewsOpinion(reviewsOpinions);
  return (
    <>
      {!reviewsAreLoading &&
        reviewsCards?.map((reviewData, idx) => {
          const isFirstCard = idx === 0;
          const reviewOpinion = extractedReviewOpinion(reviewData.reviewId);

          return (
            <ReviewCard
              breakpoint={breakpoint}
              className={jcm({
                [reviewCardFirst]: isFirstCard,
              })}
              key={reviewData.reviewId}
              reviewData={reviewData}
              onShowPicture={onShowPicture}
              reviewOpinion={reviewOpinion}
              onLike={onLike}
              onDislike={onDislike}
              onCancelLike={onCancelLike}
              onCancelDislike={onCancelDislike}
              onChangeDislikeToLike={onChangeDislikeToLike}
              onChangeLikeToDislike={onChangeLikeToDislike}
            />
          );
        })}

      {reviewsAreLoading && <ReviewsPaginationPageSkeleton />}
    </>
  );
};
